import React from "react";

const VerifyModal = ({ onClose, sessionId, explorerUrlBase }) => {
  // Create the explorer link
  const txLink = `${explorerUrlBase}/address/0x388603B9D3715E51ee9d1c6300bFB289b8fC4736?tab=read_contract`;

  // Convert sessionId to string if it's a BigInt
  const displaySessionId = sessionId ? sessionId.toString() : "Not Set";

  console.log("Session ID in VerifyModal:", displaySessionId);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="w-full max-w-lg p-6 bg-gray-800 border border-indigo-300 rounded-lg shadow-lg">
        <h2 className="mb-4 text-2xl font-bold text-center text-white">
          Verify Giveaway Results (Session #{displaySessionId})
        </h2>
        <div className="mb-4 text-white">
          <p>
            The giveaway results were determined using a deterministic algorithm on Rails Network.
            The randomness was generated from the secret combined with public block data.
          </p>
          <p className="mt-2">
            You can verify all winners by clicking the link below and using function 3 (getWinners) by inputting the session ID below.
          </p>
          <p className="mt-2">
            Cross-check the <strong>Session ID</strong> on the explorer with the one displayed here to ensure this session’s integrity.
          </p>
        </div>
        <div className="mb-4">
          <a
            href={txLink}
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
          >
            View on Rails Explorer
          </a>
        </div>
        <button
          onClick={onClose}
          className="w-full px-4 py-2 font-semibold text-white bg-gray-700 rounded hover:bg-gray-600"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default VerifyModal;
